import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';

export function ErrorBoundary() {
  const err = useRouteError();
  const nav = useNavigate();
  const message = isRouteErrorResponse(err)
    ? `${err.status} ${err.statusText}`
    : err instanceof Error
      ? err.message
      : '알 수 없는 오류가 발생했습니다.';
  return (
    <div className="mx-auto mt-20 max-w-md rounded-lg border border-ink-200 bg-paper p-6 shadow">
      <h1 className="text-lg font-semibold text-ink-900">문제가 발생했습니다</h1>
      <p className="mt-2 text-sm text-ink-600">{message}</p>
      <div className="mt-4 flex gap-2">
        <button className="btn-primary" onClick={() => nav(0)}>다시 시도</button>
        <button className="btn-secondary" onClick={() => nav('/orders')}>주문 화면으로</button>
      </div>
    </div>
  );
}
